import * as React from 'react';
import styles from './index.less';
import { Pagination, Space, Switch } from 'antd';
import Policies from './Policies';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, CreatedCollectionExhibitInfoPageModelState } from '@/models/connect';
import {
  ChangeAction,
  FetchInfoAction,
  OnMountPageAction,
  UpdateBaseInfoAction,
  OnSave_ExhibitIntroduction_Action,
  Fetch_CollectionItems_Action,
  OnSync_Options_Action,
} from '@/models/createdCollectionExhibitInfoPage';
// import FTooltip from '@/components/FTooltip';
import { RouteComponentProps } from 'react-router';
import { FUtil, FI18n, FServiceAPI } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import { onlineExhibit } from '@/pages/node/utils/tools';
import { fOnOffFeedback } from '@/components/fOnOffFeedback';
// import FCoverImage from '@/components/FCoverImage';
// import fMessage from '@/components/fMessage';
// import FUploadCover from '@/components/FUploadCover';
import FLoadingTip from '@/components/FLoadingTip';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import ResourceLabelsCard from '@/pages/node/exhibit/formal/$id/ResourceLabelsCard';
import fEditLabelsDrawer from '@/components/fEditLabelsDrawer';
import IntroductionCard from '@/pages/node/exhibit/formal/$id/IntroductionCard';
import fEditIntroductionDrawer from '@/components/fEditIntroductionDrawer';
import FIcons from '@/components/FIcons';
import FGlobalLoading from '@/components/FGlobalLoading';
import FAttrsAndConfigs from '@/components/FAttrsAndConfigs';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';
import { AutoIncludedSetting } from './AutoIncludedSetting';
import AddItemsFromExhibitsDrawer from './AddItemsFromExhibitsDrawer';
import FExhibitCollectionList from '@/components/FExhibitCollectionList';
import SortOrderModal from './SortOrderModal';
import FMicroApp_ResourceToNodeAuth from '@/components/FMicroApp_ResourceToNodeAuth';
import MicroAppStateActionsMgr from '@/utils/MicroAppStateActionsMgr';
import { FTourMgr } from '@/utils/FTourMgr';
import FNoDataTip from '@/components/FNoDataTip';
import FCoverImageEditor from '@/components/FCoverImageEditor';
import { ExhibitTitleInput } from '@/pages/node/exhibit/formal/$id';
import FInput_Search from '@/components/FInput_Search';

interface PresentableProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  createdCollectionExhibitInfoPage: CreatedCollectionExhibitInfoPageModelState;
}

function Presentable({ dispatch, createdCollectionExhibitInfoPage, match }: PresentableProps) {
  const refPromise = React.useRef<Promise<void> | null>(null);
  const ref_ItemsTitle = React.useRef<any>(null);
  const [$openAddItemsFromExhibitsDrawer, set$openAddItemsFromExhibitsDrawer] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$globalLoading, set$globalLoading, get$globalLoading] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$sortOrderModalShow, set$sortOrderModalShow] = FUtil.Hook.useGetState<boolean>(false);
  const [$showAuthResourceID, set$showAuthResourceID] = FUtil.Hook.useGetState<string>('');

  AHooks.useMount(() => {
    // console.log('onMountPage', match.params, 'match');
    dispatch<OnMountPageAction>({
      type: 'createdCollectionExhibitInfoPage/onMountPage',
      payload: {
        exhibitID: match.params.id,
      },
    });
  });

  AHooks.useMount(() => {
    setTimeout(() => {
      FTourMgr.init('node.createdCollectionExhibit', [
        {
          element: self.document.getElementById('node.createdCollectionExhibit.addItems'),
          title: FI18n.i18nNext.t('tours_editnodecollection_additems'),
          topOffset: 10,
          rightOffset: 10,
          bottomOffset: 10,
          leftOffset: 10,
        },
        {
          element: self.document.getElementById('node.createdCollectionExhibit.addPolicy'),
          title: FI18n.i18nNext.t('tours_editnodecollection_addplans'),
          topOffset: 10,
          rightOffset: 10,
          bottomOffset: 10,
          leftOffset: 10,
        },
      ]);
    }, 300);
  });

  const { run: keywordsRun } = AHooks.useDebounceFn(
    () => {
      dispatch<Fetch_CollectionItems_Action>({
        type: 'createdCollectionExhibitInfoPage/fetch_CollectionItems',
      });
    },
    {
      wait: 300,
    },
  );

  async function onChangePage(page: number, pageSize: number) {
    const collectionItems_pageCurrent =
      createdCollectionExhibitInfoPage.collectionItems_pageCurrent;
    await dispatch<ChangeAction>({
      type: 'createdCollectionExhibitInfoPage/change',
      payload: {
        collectionItems_pageCurrent: page,
        collectionItems_pageSize: pageSize,
      },
    });
    await dispatch<Fetch_CollectionItems_Action>({
      type: 'createdCollectionExhibitInfoPage/fetch_CollectionItems',
    });
    if (page !== collectionItems_pageCurrent) {
      ref_ItemsTitle.current?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }

  if (createdCollectionExhibitInfoPage.pageLoading) {
    return <FLoadingTip height={'calc(100vh - 70px)'} />;
  }

  return (
    <>
      <div className={styles.Presentable}>
        <div className={styles.content}>
          <div style={{ height: 40 }} />
          <Space size={5}>
            <FComponentsLib.FTextBtn
              onClick={() => {
                window.open(
                  FUtil.LinkTo.nodeManagement({
                    nodeID: createdCollectionExhibitInfoPage.exhibit_BelongNode_ID,
                  }),
                );
              }}
              style={{ fontWeight: 600 }}
              type='default'
            >
              <FComponentsLib.FContentText
                type={'negative'}
                text={
                  createdCollectionExhibitInfoPage.exhibit_BelongNode_Title ||
                  createdCollectionExhibitInfoPage.exhibit_BelongNode_Name
                }
                style={{ fontWeight: 600, maxWidth: 200 }}
                singleRow
              />
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FContentText type={'negative'} text={'>'} style={{ fontWeight: 600 }} />
            <FComponentsLib.FContentText
              type={'highlight'}
              text={
                createdCollectionExhibitInfoPage.exhibit_Title ||
                createdCollectionExhibitInfoPage.exhibit_Name
              }
              style={{
                maxWidth: 600,
              }}
              singleRow
            />
          </Space>
          <div style={{ height: 40 }} />
          <div className={styles.onlineSwitch}>
            {createdCollectionExhibitInfoPage.exhibit_IsAuth && (
              <FComponentsLib.FContentText
                text={
                  createdCollectionExhibitInfoPage.exhibit_Online
                    ? // ? '展品已上架'
                      FI18n.i18nNext.t('edit_exhibit_status_availableforauth')
                    : // : '展品未上架'}
                      FI18n.i18nNext.t('edit_exhibit_status_pendingauth')
                }
                type={'normal'}
                style={{ fontWeight: 600 }}
              />
            )}

            <FHotspotTooltip
              id={'exhibitDetailPage.onlineSwitch'}
              style={{ left: -42, top: -4 }}
              text={FI18n.i18nNext.t('hotpots_exhibit_toggle_exhibit')}
            >
              <Space size={20}>
                <FComponentsLib.FContentText
                  type={'highlight'}
                  text={FI18n.i18nNext.t('switch_set_exhibit_avaliable')}
                />
                <Switch
                  disabled={
                    !createdCollectionExhibitInfoPage.exhibit_IsAuth &&
                    !createdCollectionExhibitInfoPage.exhibit_Online
                  }
                  checked={createdCollectionExhibitInfoPage.exhibit_Online}
                  className={styles.CustomSwitch}
                  onChange={async (checked) => {
                    if (checked) {
                      await onlineExhibit({
                        exhibit_ID: createdCollectionExhibitInfoPage.exhibit_ID,
                        async onStartOnline() {
                          set$globalLoading(true);
                        },
                        async onEndOnline() {
                          set$globalLoading(false);
                          await refPromise.current;
                        },
                      });
                    } else {
                      const confirm: boolean = await fPromiseModalConfirm({
                        // title: '下架展品',
                        // description: '下架后，其它用户将无法签约该展品，确认要下架吗？',
                        title: '提示',
                        description: FI18n.i18nNext.t('confirm_msg_remove_exhibits_from_auth'),
                        okText: FI18n.i18nNext.t('btn_remove_exhibits_from_auth'),
                        promptKey_localStorage: 'offlineExhibit',
                      });

                      if (confirm) {
                        const params2: Parameters<
                          typeof FServiceAPI.Exhibit.presentablesOnlineStatus
                        >[0] = {
                          presentableId: createdCollectionExhibitInfoPage.exhibit_ID,
                          onlineStatus: 0,
                        };
                        set$globalLoading(true);
                        await FServiceAPI.Exhibit.presentablesOnlineStatus(params2);
                        set$globalLoading(false);
                        await refPromise.current;

                        fOnOffFeedback({
                          state: 'off',
                          message: FI18n.i18nNext.t('remove_resource_from_auth_msg_done'),
                        });
                      }
                    }
                    fSetHotspotTooltipVisible('exhibitDetailPage.onlineSwitch', {
                      value: false,
                      effectiveImmediately: true,
                      onlyNullish: false,
                    });
                    // dispatch<ChangeAction>({
                    //   type: 'createdCollectionExhibitInfoPage/change',
                    //   payload: {
                    //     exhibit_Online: checked,
                    //   },
                    // });
                    // await FUtil.Tool.promiseSleep(5000);
                    await dispatch<FetchInfoAction>({
                      type: 'createdCollectionExhibitInfoPage/fetchInfo',
                    });
                  }}
                />
              </Space>
            </FHotspotTooltip>
            {!createdCollectionExhibitInfoPage.exhibit_IsAuth && (
              <Space size={5}>
                <FIcons.FWarning style={{ fontSize: 16 }} />
                <FComponentsLib.FContentText type={'additional2'} style={{ color: '#222' }}>
                  {createdCollectionExhibitInfoPage.exhibit_AuthErrorText}
                </FComponentsLib.FContentText>
              </Space>
            )}
          </div>

          <div style={{ height: 5 }} />
          <div className={styles.exhibitInfo}>
            {/* <FUploadCover
              style={{ height: 195 }}
              use={'exhibit'}
              onError={(err) => {
                fMessage(err, 'error');
              }}
              onUploadSuccess={(url: string) => {
                // console.log(url, 'url@#$!@#$@#@#$@#');
                dispatch<UpdateBaseInfoAction>({
                  type: 'createdCollectionExhibitInfoPage/updateBaseInfo',
                  payload: {
                    exhibit_Cover: url,
                  },
                });
              }}
            >
              <div className={styles.cover}>
                <FCoverImage
                  src={createdCollectionExhibitInfoPage.exhibit_Cover || ''}
                  // src={''}
                  width={260}
                  style={{ borderRadius: 6 }}
                />
                <div className={styles.coverEdit}>
                  <FIcons.FEdit style={{ fontSize: 32 }} />
                  <div style={{ height: 10 }} />
                  <div>{FI18n.i18nNext.t('btn_edit_cover')}</div>
                </div>
              </div>
            </FUploadCover> */}

            <FCoverImageEditor
              src={createdCollectionExhibitInfoPage.exhibit_Cover || ''}
              width={260}
              onChange={(url) => {
                dispatch<UpdateBaseInfoAction>({
                  type: 'createdCollectionExhibitInfoPage/updateBaseInfo',
                  payload: {
                    exhibit_Cover: url,
                  },
                });
              }}
            />

            <div className={styles.info}>
              <div>
                <ExhibitTitleInput
                  value={createdCollectionExhibitInfoPage.exhibit_Title}
                  onOK={(value) => {
                    dispatch<UpdateBaseInfoAction>({
                      type: 'createdCollectionExhibitInfoPage/updateBaseInfo',
                      payload: {
                        exhibit_Title: value,
                      },
                    });
                  }}
                />
                <div style={{ height: 5 }} />
                <Space size={4}>
                  <FComponentsLib.FContentText
                    type={'additional2'}
                    // text={'合集'}
                    text={createdCollectionExhibitInfoPage.exhibit_ReourceType.join('/')}
                    style={{ color: '#999' }}
                  />

                  <FComponentsLib.FContentText
                    type={'additional2'}
                    text={'|'}
                    style={{ color: '#999' }}
                  />

                  <FComponentsLib.FContentText
                    type={'additional2'}
                    // text={'合集'}
                    text={FI18n.i18nNext.t('edit_exhibit_collection')}
                    style={{ color: '#999' }}
                  />

                  <FComponentsLib.FContentText
                    type={'additional2'}
                    text={'|'}
                    style={{ color: '#999' }}
                  />

                  <FComponentsLib.FContentText
                    type={'additional2'}
                    // text={`展品标识：${collectionExhibitInfoPage.exhibit_BelongNode_Name}/${collectionExhibitInfoPage.exhibit_Name}`}
                    text={`${FI18n.i18nNext.t('edit_exhibit_exhibitauthid')}${
                      createdCollectionExhibitInfoPage.exhibit_BelongNode_Name
                    }/${createdCollectionExhibitInfoPage.exhibit_Name}`}
                    style={{ color: '#999', maxWidth: 200 }}
                    singleRow
                  />
                </Space>
              </div>
              <div style={{ height: 20 }} />
              <ResourceLabelsCard
                labels={createdCollectionExhibitInfoPage.exhibit_ExhibitTags}
                onClick={async () => {
                  const result: null | string[] = await fEditLabelsDrawer({
                    labels: createdCollectionExhibitInfoPage.exhibit_ExhibitTags,
                  });
                  if (result === null) {
                    return;
                  }

                  dispatch<UpdateBaseInfoAction>({
                    type: 'createdCollectionExhibitInfoPage/updateBaseInfo',
                    payload: {
                      exhibit_ExhibitTags: result,
                    },
                  });
                }}
              />
              <div style={{ height: 10 }} />
              <IntroductionCard
                text={createdCollectionExhibitInfoPage.exhibit_ExhibitIntroduction}
                onClick={async () => {
                  const result: null | string = await fEditIntroductionDrawer({
                    text: createdCollectionExhibitInfoPage.exhibit_ExhibitIntroduction,
                  });
                  if (result === null) {
                    return;
                  }

                  dispatch<OnSave_ExhibitIntroduction_Action>({
                    type: 'createdCollectionExhibitInfoPage/onSave_ExhibitIntroduction',
                    payload: {
                      value: result,
                    },
                  });
                }}
              />
            </div>
          </div>
          <div style={{ height: 5 }} />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <FComponentsLib.FTextBtn
              style={{ fontSize: 12 }}
              onClick={() => {
                dispatch<ChangeAction>({
                  type: 'createdCollectionExhibitInfoPage/change',
                  payload: {
                    settingUnfold: !createdCollectionExhibitInfoPage.settingUnfold,
                  },
                });
              }}
            >
              {createdCollectionExhibitInfoPage.settingUnfold
                ? FI18n.i18nNext.t('brr_resourcelisting_item_btn_showlesssetting')
                : FI18n.i18nNext.t('edit_exhibit_moresetting_btn')}
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FContentText
              text={
                // '自定义信息'
                FI18n.i18nNext.t('edit_exhibit_moresetting_info2')
              }
              type={'negative'}
              style={{ fontSize: 12 }}
            />
          </div>

          {createdCollectionExhibitInfoPage.settingUnfold && (
            <>
              <div style={{ height: 5 }} />
              <div className={styles.block} style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FComponentsLib.FContentText
                    // text={'自定义信息'}
                    text={FI18n.i18nNext.t('edit_exhibit_customdata')}
                    type={'highlight'}
                  />
                  {createdCollectionExhibitInfoPage.customOptions.length < 30 && (
                    <FComponentsLib.FTextBtn
                      style={{
                        fontSize: 12,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5,
                      }}
                      type='primary'
                      onClick={async () => {
                        const dataSource: {
                          key: string;
                          name: string;
                          description: string;
                        } | null = await fResourcePropertyEditor3({
                          disabledKeys: [
                            ...createdCollectionExhibitInfoPage.customOptions.map((co) => co.key),
                          ],
                          disabledNames: [],
                        });

                        if (!dataSource) {
                          return;
                        }

                        await dispatch<ChangeAction>({
                          type: 'createdCollectionExhibitInfoPage/change',
                          payload: {
                            customOptions: [
                              ...createdCollectionExhibitInfoPage.customOptions,
                              { ...dataSource, value: '' },
                            ],
                          },
                        });

                        dispatch<OnSync_Options_Action>({
                          type: 'createdCollectionExhibitInfoPage/onSync_Options',
                        });
                      }}
                    >
                      <FIcons.FConfiguration style={{ fontSize: 14 }} />
                      {/*<span>添加自定义信息</span>*/}
                      <span>{FI18n.i18nNext.t('edit_exhibit_btn_addcustomdata')}</span>
                    </FComponentsLib.FTextBtn>
                  )}
                </div>

                {
                  // info.customConfigurations.length === 0 && (<>
                  createdCollectionExhibitInfoPage.customOptions.length === 0 && (
                    <>
                      <div style={{ height: 10 }} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <FComponentsLib.FContentText
                          // text={'自定义信息是资源在消费端展示时所需的配置信息，您可以根据需要添加。'}
                          text={FI18n.i18nNext.t('edit_exhibit_customdata_info')}
                          type={'additional2'}
                        />
                      </div>
                      <div style={{ height: 20 }} />
                    </>
                  )
                }

                {createdCollectionExhibitInfoPage.customOptions.length > 0 && (
                  <>
                    <div style={{ height: 20 }} />

                    <FAttrsAndConfigs
                      dateSource={createdCollectionExhibitInfoPage.customOptions.map((co) => ({
                        key: co.key,
                        name: co.name,
                        value: co.value,
                        description: co.description,
                        configs: {
                          item_Deletable: true,
                          key_Editable: true,
                          name_Editable: true,
                          description_Editable: true,
                          value_Editable: {
                            text: {
                              nullable: true,
                              minLength: 1,
                              maxLength: 140,
                            },
                          },
                        },
                      }))}
                      onChange={(dataSource, changedFields) => {
                        dispatch<ChangeAction>({
                          type: 'createdCollectionExhibitInfoPage/change',
                          payload: {
                            customOptions: dataSource.map((co) => ({
                              key: co.key,
                              name: co.name,
                              value: co.value,
                              description: co.description,
                            })),
                          },
                        });
                        dispatch<OnSync_Options_Action>({
                          type: 'createdCollectionExhibitInfoPage/onSync_Options',
                          payload: {
                            successMessage: changedFields.includes('value')
                              ? FI18n.i18nNext.t('saved_successfully')
                              : undefined,
                          },
                        });
                      }}
                      disabledKeys={[]}
                      disabledNames={[]}
                    />
                  </>
                )}
              </div>
            </>
          )}

          <div style={{ height: 15 }} />

          <div className={styles.block}>
            <div ref={ref_ItemsTitle} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <FComponentsLib.FContentText
                // text={'单品资源管理'}
                text={FI18n.i18nNext.t('edit_exhibit_collection_itemmgnt')}
                type={'highlight'}
              />

              {(createdCollectionExhibitInfoPage.collectionItems_state === 'loaded' ||
                createdCollectionExhibitInfoPage.collectionItems_state === 'noSearchResult') && (
                <FComponentsLib.FTextBtn
                  style={{
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 5,
                  }}
                  type='primary'
                  onClick={async () => {
                    set$openAddItemsFromExhibitsDrawer(true);
                  }}
                >
                  <FIcons.FAdd style={{ fontSize: 14 }} />
                  {/*<span>添加单品资源</span>*/}
                  <span>{FI18n.i18nNext.t('cqr_itemmgmt_btn_additem')}</span>
                </FComponentsLib.FTextBtn>
              )}
            </div>

            {createdCollectionExhibitInfoPage.collectionItems_state === 'loading' && (
              <FLoadingTip height={600} />
            )}

            {createdCollectionExhibitInfoPage.collectionItems_state === 'noData' && (
              <>
                <div style={{ height: 10 }} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <FComponentsLib.FContentText
                    text={
                      // 你添加的资源将会显示在这里
                      FI18n.i18nNext.t('edit_exhibitcollection_itemes_empty')
                    }
                    type={'additional2'}
                  />
                  <div style={{ height: 20 }} />
                  <div
                    style={{ width: 'fit-content', height: 'fit-content' }}
                    id='node.createdCollectionExhibit.addItems'
                  >
                    <FComponentsLib.FRectBtn
                      onClick={async () => {
                        set$openAddItemsFromExhibitsDrawer(true);
                      }}
                    >
                      {
                        // 添加单品
                        FI18n.i18nNext.t('edit_exhibitcollection_itemes_btn_additem')
                      }
                    </FComponentsLib.FRectBtn>
                  </div>
                </div>
                <div style={{ height: 20 }} />
              </>
            )}

            {(createdCollectionExhibitInfoPage.collectionItems_state === 'noSearchResult' ||
              createdCollectionExhibitInfoPage.collectionItems_state === 'loaded') && (
              <>
                <div style={{ height: 20 }} />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                    <FComponentsLib.FContentText
                      // text={`单品数量 ${collectionExhibitInfoPage.collectionItems_totalCount}`}
                      text={FI18n.i18nNext.t('edit_exhibit_collection_itemmgnt_count', {
                        itemCount: createdCollectionExhibitInfoPage.collectionItems_totalCount,
                      })}
                      type={'additional2'}
                      style={{ color: '#222' }}
                    />
                    <FComponentsLib.FTextBtn
                      type={'primary'}
                      style={{ fontSize: 12 }}
                      onClick={() => {
                        // set$collectionSettingExpansion(get$collectionSettingExpansion() === 'sort' ? '' : 'sort');
                        set$sortOrderModalShow(true);
                      }}
                    >
                      {/* 调整排序 */}
                      {FI18n.i18nNext.t('edit_exhibitcollection_items_sort')}
                    </FComponentsLib.FTextBtn>
                  </div>
                  {/* <FComponentsLib.FInput.FSearch */}
                  <FInput_Search
                    value={createdCollectionExhibitInfoPage.collectionItems_keywords}
                    onChange={(e) => {
                      dispatch<ChangeAction>({
                        type: 'createdCollectionExhibitInfoPage/change',
                        payload: {
                          collectionItems_keywords: e.target.value,
                          collectionItems_pageCurrent: 1,
                        },
                      });
                      keywordsRun();
                    }}
                    placeholder={FI18n.i18nNext.t('cqr_itemmgmt_search_hint')}
                  />
                </div>
                <div style={{ height: 20 }} />
              </>
            )}
            {createdCollectionExhibitInfoPage.collectionItems_state === 'noSearchResult' && (
              <FNoDataTip
                height={300}
                tipText={
                  // '没有找到相关资源'
                  FI18n.i18nNext.t('msg_search_no_resault_found', {
                    SearchKeyWords: createdCollectionExhibitInfoPage.collectionItems_keywords,
                  })
                }
              />
            )}
            {createdCollectionExhibitInfoPage.collectionItems_state === 'loaded' && (
              <>
                <FExhibitCollectionList
                  showCover={'show'}
                  showNumber={'show'}
                  showTitle={'title'}
                  showIntroduction={'show'}
                  items={createdCollectionExhibitInfoPage.collectionItems}
                  showCheckbox={'hide'}
                  checkedItemIDs={[]}
                  onClick={(itemID, exhibitID, resourceID) => {
                    set$showAuthResourceID(resourceID);
                    MicroAppStateActionsMgr.setState({
                      authProcessorShow: true,
                      licensorId: resourceID,
                    });
                  }}
                  onClickDelete={async (itemID) => {
                    const { data } = await FServiceAPI.Exhibit.removeItemsFromPresentableCollection(
                      {
                        presentableId: createdCollectionExhibitInfoPage.exhibit_ID,
                        removeIds: itemID,
                        idType: 'itemId',
                      },
                    );
                    await dispatch<ChangeAction>({
                      type: 'createdCollectionExhibitInfoPage/change',
                      payload: {
                        collectionItems_pageCurrent: Math.min(
                          Math.floor(
                            (createdCollectionExhibitInfoPage.collectionItems_totalCount - 1) /
                              createdCollectionExhibitInfoPage.collectionItems_pageSize,
                          ) + 1,
                          createdCollectionExhibitInfoPage.collectionItems_pageCurrent,
                        ),
                      },
                    });
                    await dispatch<Fetch_CollectionItems_Action>({
                      type: 'createdCollectionExhibitInfoPage/fetch_CollectionItems',
                    });
                  }}
                />
              </>
            )}

            {createdCollectionExhibitInfoPage.collectionItems_totalCount > 10 && (
              <>
                <div style={{ height: 20 }} />

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Pagination
                    showTitle={false}
                    locale={{
                      items_per_page: '条/页',
                      jump_to: '前往',
                      page: '页',
                    }}
                    size='small'
                    showSizeChanger
                    showQuickJumper
                    current={createdCollectionExhibitInfoPage.collectionItems_pageCurrent}
                    pageSize={createdCollectionExhibitInfoPage.collectionItems_pageSize}
                    total={createdCollectionExhibitInfoPage.collectionItems_totalCount}
                    onChange={onChangePage}
                    showTotal={(total) => {
                      return `共${total}条`;
                    }}
                    pageSizeOptions={[10, 20, 30, 40, 50]}
                  />
                </div>
              </>
            )}
          </div>

          <div style={{ height: 5 }} />

          <AutoIncludedSetting
            nodeName={createdCollectionExhibitInfoPage.exhibit_BelongNode_Name}
            exhibitID={createdCollectionExhibitInfoPage.exhibit_ID}
          />

          <div style={{ height: 5 }} />

          <Policies />

          <div style={{ height: 100 }} />
        </div>
        <FGlobalLoading
          open={$globalLoading}
          onOpened={(promise) => {
            refPromise.current = promise;
          }}
          onClosed={() => {}}
        />
      </div>
      <AddItemsFromExhibitsDrawer
        open={$openAddItemsFromExhibitsDrawer}
        nodeID={createdCollectionExhibitInfoPage.exhibit_BelongNode_ID}
        exhibitID={createdCollectionExhibitInfoPage.exhibit_ID}
        onClose={() => {
          set$openAddItemsFromExhibitsDrawer(false);
          dispatch<ChangeAction>({
            type: 'createdCollectionExhibitInfoPage/change',
            payload: {
              collectionItems_pageCurrent: 1,
            },
          });
          dispatch<Fetch_CollectionItems_Action>({
            type: 'createdCollectionExhibitInfoPage/fetch_CollectionItems',
          });
        }}
      />

      <SortOrderModal
        open={$sortOrderModalShow}
        setting={createdCollectionExhibitInfoPage.collectionItemsSetting}
        collectionItems={createdCollectionExhibitInfoPage.collectionItems}
        onChangeSetting={async (value) => {
          dispatch<ChangeAction>({
            type: 'createdCollectionExhibitInfoPage/change',
            payload: {
              collectionItemsSetting: value,
            },
          });
        }}
        onChangeSortSetting={async (sort) => {
          await FServiceAPI.Exhibit.updatePresentableCollection({
            presentableId: createdCollectionExhibitInfoPage.exhibit_ID,
            catalogueProperty: {
              collection_sort_list: sort,
            },
          });
          await dispatch<ChangeAction>({
            type: 'createdCollectionExhibitInfoPage/change',
            payload: {
              collectionItems_pageCurrent: 1,
            },
          });
          await dispatch<Fetch_CollectionItems_Action>({
            type: 'createdCollectionExhibitInfoPage/fetch_CollectionItems',
          });
        }}
        onClickSortBy={async (sort: 'added' | 'title' | 'releaseDate') => {
          const { ret, errCode, msg, data } =
            await FServiceAPI.Exhibit.setItemsSortFromPresentableCollectionQuick({
              presentableId: createdCollectionExhibitInfoPage.exhibit_ID,
              sortField:
                sort === 'added'
                  ? 'createDate'
                  : sort === 'title'
                  ? 'itemTitle'
                  : 'resourceFirstVersionReleaseDate',
              sortType: sort === 'added' ? -1 : sort === 'title' ? 1 : -1,
            });
          await dispatch<Fetch_CollectionItems_Action>({
            type: 'createdCollectionExhibitInfoPage/fetch_CollectionItems',
          });
        }}
        onChangeItemsSortID={async (itemIDs: string[], sortID: number) => {
          await FServiceAPI.Exhibit.setItemsSortFromPresentableCollectionManual({
            presentableId: createdCollectionExhibitInfoPage.exhibit_ID,
            itemIds: itemIDs,
            targetSortId: sortID,
          });
          await dispatch<Fetch_CollectionItems_Action>({
            type: 'createdCollectionExhibitInfoPage/fetch_CollectionItems',
          });
        }}
        pageSize={createdCollectionExhibitInfoPage.collectionItems_pageSize}
        pageCurrent={createdCollectionExhibitInfoPage.collectionItems_pageCurrent}
        totalCount={createdCollectionExhibitInfoPage.collectionItems_totalCount}
        onChangePage={onChangePage}
        onCancel={() => {
          set$sortOrderModalShow(false);
        }}
      />

      {$showAuthResourceID !== '' && (
        <FMicroApp_ResourceToNodeAuth
          nodeID={createdCollectionExhibitInfoPage.exhibit_BelongNode_ID}
          onClose={() => {
            set$showAuthResourceID('');
          }}
        />
      )}
    </>
  );
}

export default connect(({ createdCollectionExhibitInfoPage }: ConnectState) => ({
  createdCollectionExhibitInfoPage,
}))(Presentable);

// interface TitleInputProps {
//   value: string;

//   onOK(value: string): void;

//   // onCancel(): void;
// }

// function TitleInput({ value, onOK }: TitleInputProps) {
//   const [$isEdit, set$isEdit, get$isEdit] = FUtil.Hook.useGetState<boolean>(false);
//   const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>(value);
//   const [$valueError, set$valueError, get$valueError] = FUtil.Hook.useGetState<string>('');

//   function onEdit() {
//     set$isEdit(true);
//     set$value(value);
//   }

//   if (!$isEdit) {
//     return (
//       <Space size={10}>
//         {value === '' && (
//           <>
//             <FComponentsLib.FTextBtn
//               onClick={() => {
//                 onEdit();
//               }}
//             >
//               <FIcons.FAdd />
//             </FComponentsLib.FTextBtn>
//             <FComponentsLib.FTextBtn
//               onClick={() => {
//                 onEdit();
//               }}
//             >
//               添加标题
//             </FComponentsLib.FTextBtn>
//           </>
//         )}

//         {value !== '' && (
//           <>
//             <FComponentsLib.FTitleText
//               type={'h2'}
//               text={value}
//               style={{ overflowWrap: 'anywhere', fontWeight: 600 }}
//             />
//             <FTooltip title={'编辑'}>
//               <div>
//                 <FComponentsLib.FTextBtn
//                   onClick={() => {
//                     onEdit();
//                   }}
//                 >
//                   <FIcons.FEdit style={{ fontSize: 12 }} />
//                 </FComponentsLib.FTextBtn>
//               </div>
//             </FTooltip>
//           </>
//         )}
//       </Space>
//     );
//   }

//   return (
//     <div>
//       <Space size={10}>
//         <FComponentsLib.FInput.FSingleLine
//           lengthLimit={-1}
//           className={styles.FInput}
//           style={{ width: 440 }}
//           // wrapClassName={styles.FInput}
//           value={$value}
//           onChange={(e) => {
//             set$value(e.target.value);
//             set$valueError(e.target.value.length > 100 ? '不能超过100个字符' : '');
//           }}
//           placeholder={'请输入标题'}
//         />
//         <FComponentsLib.FRectBtn
//           type={'primary'}
//           disabled={$value === '' || $valueError !== ''}
//           onClick={() => {
//             onOK(get$value());
//             set$isEdit(false);
//           }}
//         >
//           {FI18n.i18nNext.t('edit_exhibit_btn_save_title')}
//         </FComponentsLib.FRectBtn>
//         <FComponentsLib.FRectBtn
//           type='default'
//           onClick={() => {
//             set$isEdit(false);
//           }}
//         >
//           {FI18n.i18nNext.t('edit_exhibit_btn_cancel')}
//         </FComponentsLib.FRectBtn>
//       </Space>

//       {$valueError !== '' && (
//         <>
//           <div style={{ height: 5 }} />
//           <div style={{ color: '#EE4040' }}>{$valueError}</div>
//         </>
//       )}
//     </div>
//   );
// }
